import React, { useContext } from 'react';
import { QrReader } from 'react-qr-reader';
import styles from './ScanQrChecker.module.css';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header/Header';
import { WelletContext } from '../../context/WelletContext';
import { useParams } from 'react-router-dom';
import encodeQueryParams from '../../helpers/encodeUri';

import Button from '../../components/Common/Button/Button';
const ScanQrChecker = ({ history }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation();
  const { id } = useParams();

  const checkin = async (referenceCode) => {
    try {
      const result = await welletContext.apis.tickets.post(
        `/api/checkin/CheckInTicket?check=${false}`,
        {
          token: referenceCode,
          EventId: id,
          DeviceId: null,
        },
      );

      const params = {
        referenceCode,
        id,
        showName: result.data.ticketCheck.name,
        codeTicket: result.data.ticketCheck.referenceCode,
      };

      const path = result.data.success
        ? `/qr-scan-exit?${encodeQueryParams(params)}`
        : `/qr-scan-error?${encodeQueryParams({
            ...params,
            errorType: result.data.errorType,
          })}`;

      history.push(path);
    } catch (error) {
      console.error(error);
      history.push(`/qr-scan-error?${encodeQueryParams({ referenceCode, id })}`);
    }
  };

  const handleScan = (data) => {
    if (data) {
      checkin(data.text);
    } else {
      history.push('/qr-scan-error');
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  return (
    <>
      <div className={styles.scanPaymentContainer}>
        <div className={styles.qrScannerWrapper}>
          <Header pathName={`/check-show/${id}`} />
          <QrReader
            onResult={(result, error) => {
              if (!!result) {
                handleScan(result);
              }
              if (!!error) {
                handleError(error);
              }
            }}
            constraints={{
              facingMode: 'environment',
            }}
            className={styles.qr}
          />
          <div className={styles.qrScannerOverlay}>
            <div className={styles.cornerTopLeft}></div>
            <div className={styles.cornerTopRight}></div>
            <div className={styles.cornerBottomLeft}></div>
            <div className={styles.cornerBottomRight}></div>
            <div className={styles.scannerLine}></div>
          </div>
        </div>

        <div className={styles.scanInstructions}>
          <div className={styles.customLine}></div>
          {t('scanTheCode')}

          <div className='mt-5 pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
            <div className='mb-2'>
              <Button
                onClick={() =>

                  history.push({
                    pathname: `/manual-qr-checker/${id}`,
      
                  })}
                size={'normal'}
                text={t('enterManually')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScanQrChecker;
